import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, BookOpen, Zap, TrendingUp, User } from 'lucide-react';

const tabs = [
  { id: 'home', label: 'Home', icon: Home, path: '/home' },
  { id: 'practice', label: 'Practice', icon: BookOpen, path: '/practice' },
  { id: 'zeno', label: 'Zeno', icon: Zap, path: '/zeno' },
  { id: 'progress', label: 'Progress', icon: TrendingUp, path: '/progress' },
  { id: 'profile', label: 'Profile', icon: User, path: '/profile' },
];

export default function BottomNav({ active }) {
  const navigate = useNavigate();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t-2 h-[72px] flex justify-around items-center z-50"
      style={{ borderColor: '#E5DACE', boxShadow: '0 -4px 20px rgba(0,0,0,0.03)' }}
      data-testid="bottom-nav">
      {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = active === tab.id;
        return (
          <button key={tab.id} data-testid={`nav-${tab.id}`} onClick={() => navigate(tab.path)}
            className="flex flex-col items-center gap-0.5 px-3 py-1 transition-all"
            style={{ color: isActive ? '#FF6B35' : '#8B7355' }}>
            {tab.id === 'zeno' ? (
              <div className="w-10 h-10 rounded-full flex items-center justify-center -mt-4"
                style={{ background: isActive ? '#FF6B35' : '#F0E6D8', boxShadow: isActive ? '0 3px 0 #C04918' : 'none' }}>
                <span className="text-lg">{isActive ? '🦉' : '🦉'}</span>
              </div>
            ) : (
              <Icon size={20} strokeWidth={isActive ? 2.5 : 2} />
            )}
            <span className="text-[10px] font-bold">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
